import React from "react";
import usePeriodicStats from "@shared/features/bots/BotForm/Backtesting/usePeriodicStats";
import { MarketplaceSubGroup } from "@shared/types";
import LineChart from "common/Charts/LineChart/LineChart";
import { useTheme } from "styled-components";
import PriceChange from "common/Charts/PriceChange";
import Flex from "common/Boxes/Flex";
import { getNetPnlChange } from "@shared/features/newMarketplace/utils";
import { useSelector } from "react-redux";
import { selectDisplayCurrency } from "@shared/slices/common.slice";
import Text from "common/Typography/Text";
import { typography } from "@shared/common/Themes/typography";

interface PnlChartProps {
  group: MarketplaceSubGroup;
  height?: number;
  showChange?: boolean;
  title?: string;
}

const PnlChart = ({ group, height, showChange, title }: PnlChartProps) => {
  const theme = useTheme();
  const displayCurrency = useSelector(selectDisplayCurrency);
  const oneMonthBacktesting = group?.timeframe_to_backtesting_run_data?.[30];
  const periodicStatsData = oneMonthBacktesting?.periodic_stats;
  const color = theme.colors.primaryBlue;

  const { netPnlLineChart } = usePeriodicStats({
    backtestingRun: oneMonthBacktesting,
    periodicStatsData,
    isGraphMinified: true,
    numPoints: showChange ? 30 : 50,
  });

  const change = getNetPnlChange(group, 30, displayCurrency);

  if (!netPnlLineChart.length) return null;

  return (
    <Flex $flexDirection="column" $justifyContent="center">
      {!!title && (
        <Flex style={{ width: "100%" }}>
          <Text type="secondary" $size={typography.fontSizes.S}>
            {title}
          </Text>
          {showChange && (
            <PriceChange
              size={12}
              change={change}
              isNeutral={true}
              isAbsoluteValue={false}
            />
          )}
        </Flex>
      )}
      <LineChart
        data={netPnlLineChart}
        isMinified={true}
        color={color}
        height={height}
      />
      {showChange && !title && (
        <PriceChange
          size={10}
          change={change}
          isNeutral={true}
          isAbsoluteValue={false}
          style={{ marginTop: 4 }}
        />
      )}
    </Flex>
  );
};

export default PnlChart;
